<template>
  <div>
    <base-header class="pb-4" />

    <div class="container-fluid mt--4">
      <b-card class="mb-4">
        <b-tabs pills card vertical v-model="active" class="custom-tabs">
          <b-tab :title="$t('Gelir Kategorileri')">
            <div v-if="active === 0">
              <categories type="income" title="Gelir Kategorileri" />
            </div>
          </b-tab>

          <b-tab :title="$t('Gider Kategorileri')">
            <div v-if="active === 1">
              <categories type="expense" title="Gider Kategorileri" />
            </div>
          </b-tab>

          <b-tab :title="$t('Cari Grupları')">
            <div v-if="active === 2">
              <categories type="company-groups" title="Cari Grupları" />
            </div>
          </b-tab>

          <b-tab :title="$t('Ürün Kategorileri')">
            <div v-if="active === 3">
              <categories type="product-categories" title="Ürün Kategorileri" />
            </div>
          </b-tab>

          <b-tab :title="$t('Ürün Markaları')">
            <div v-if="active === 4">
              <categories type="product-brands" title="Ürün Markaları" />
            </div>
          </b-tab>

          <b-tab :title="$t('Birimler')">
            <div v-if="active === 5">
              <categories type="units" title="Birimler" />
            </div>
          </b-tab>

          <!-- <b-tab :title="$t('Sabit SMS\'ler')">
            <div v-if="active === 6">
              <definitions-table type="sms" title="Sabit SMS'ler" />
            </div>
          </b-tab> -->

          <!-- <b-tab :title="$t('Satış Sözleşmesi')">
            <div v-if="active === 6">
              <sales-contract />
            </div>
          </b-tab> -->
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import SalesContract from './SalesContract';
import LeaseContract from './LeaseContract';
import OrderContract from './OrderContract';
import DefinitionsTable from './DefinitionsTable';
import Categories from './Categories';
import DryContract from './DryContract';
import TailorContract from './TailorContract';

export default {
  name: 'Definitions',
  components: {
    Categories,
    DefinitionsTable,
    SalesContract,
    LeaseContract,
    OrderContract,
    TailorContract,
    DryContract,
  },
  data() {
    return {
      active: 0,
    };
  },
};
</script>
